(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("123Reg", [], factory);
	else if(typeof exports === 'object')
		exports["123Reg"] = factory();
	else
		root["123Reg"] = factory();
})(window, function() {
return 